import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import axiosInstance from '../../axiosConfig';

const fetchNotifications = async (params) => {
  const response = await axiosInstance.get('/notifications/', {
    params,
  });
  return response.data;
};

export const useGetNotifications = (params = {}, options = {}) => {
  const queryParams = useMemo(() => {
    const out = {};
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') out[k] = v;
    });
    return out;
  }, [params]);

  const { data, error, isLoading, isError, refetch, isFetching } = useQuery({
    queryKey: ['notifications', 'list', queryParams],
    queryFn: () => fetchNotifications(queryParams),
    enabled: options.enabled ?? true,
    staleTime: 30 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });

  return {
    notifications: data?.results,
    count: data?.count,
    next: data?.next,
    previous: data?.previous,
    error,
    isLoading,
    isError,
    isFetching,
    refetch,
  };
};
